import React, { useEffect, useState } from 'react';
import { Button, Card, Table, Modal, Row, Col } from 'antd';
import PageTitle from '../../components/PageTitle';
import IntlMessage from '../../components/IntlMessage';
import ActionBar from '../../components/ActionBar';
import { useIntl } from 'react-intl';
import FilterBar from '../../components/FilterBar';
import _, { debounce } from 'lodash';
import addonsApi from '../../api/addons';
import AddonsForm from './AddonsForm';
import Currency from '../../components/Currency';

const Addons = () => {
  // states
  const [item, setItem] = useState(null);
  const [modal, setModal] = useState(false);
  const [reload, setReload] = useState(true);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });
  const [condition, setCondition] = useState({});
  // const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  // side effects
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        let items = await addonsApi.getAll(filter);

        setItems(items.data);
        setLoading(false);
        // setDeleting(false);
        if (total !== items.total) {
          setTotal(items.total);
        }
      } catch (error) {
        console.error('get all cabin error: ', error);
        setLoading(false);
      }
    }
    fetchData();
  }, [filter, reload]);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const onOpenModal = (record = null) => {
    setModal(true);
    setItem(record);
    // console.log(record);
  };

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onFilter = debounce(async (value, title, type) => {
    if (type === 'search') {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const intl = useIntl();

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const onCloseModal = () => {
    setModal(false);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onDelete = async (selectedRowKeys) => {
    // console.log('Deleted');
    await addonsApi.delete(selectedRowKeys).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    // setDeleting(true);
    onReload();
  };

  const columns = [
    {
      title: <IntlMessage id="global.no" />,
      width: 20,
      render: (text, record, index) => {
        return index + 1 + filter.limit * (filter.page - 1);
      },
    },
    {
      title: <IntlMessage id="global.title" />,
      key: 'title',
      sorter: true,
      dataIndex: 'title',
      render: (text, record) => {
        return (
          <>
            <Button
              type="link"
              size="small"
              onClick={() => onOpenModal(record)}
              shape="round">
              {record.title}
            </Button>
          </>
        );
      },
    },
    // {
    //   title: <IntlMessage id="global.email" />,
    //   key: 'email',
    //   sorter: true,
    //   dataIndex: 'email',
    //   render: (text, record) => {
    //     return record.email;
    //   },
    // },
    {
      title: <IntlMessage id="global.price" />,
      key: 'price',
      sorter: true,
      dataIndex: 'price',
      render: (text, record) => {
        return <Currency value={record.price} />;
      },
    },
    {
      title: <IntlMessage id="global.type" />,
      key: 'type',
      sorter: true,
      dataIndex: 'type',
      render: (text, record) => {
        return record.type;
      },
    },
  ];

  return (
    <Card bordered={false} style={{ minHeight: '100%' }}>
      <Row justify={'space-between'}>
        <Col>
          {' '}
          <PageTitle title={<IntlMessage id="global.addons" />} />
        </Col>

        <Col>
          <ActionBar
            onDelete={() => onDelete(selectedRowKeys)}
            isShowAddButton={true}
            onAdd={onOpenModal}
            onRefresh={() => onReload()}
            isShowPublishButtons={false}
            isShowCopyButton={false}
            isShowDeleteButton={true}
            isDisabled={!(selectedRowKeys.length > 0)}></ActionBar>
        </Col>
      </Row>

      <FilterBar onFilter={onFilter} />

      <br />

      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={items}
        onChange={onChangeTable}
        rowKey="id"
        size="small"
        loading={loading}
        scroll={{
          x: 'max-content',
        }}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          total: total,
          current: filter.page,
          pageSize: filter.limit,
        }}
        rowSelection={rowSelection}
      />

      {modal ? (
        <AddonsForm
          open={modal}
          onClose={onCloseModal}
          currentData={item}
          onReload={onReload}
        />
      ) : null}
    </Card>
  );
};

export default Addons;
